import { orderTermIsNet60 } from "../../utils/orderTermIsNet60";
import { orderTermIsPaymentOnShipment } from "../../utils/orderTermIsPaymentOnShipment";
import { orderWasAlreadyCharged } from "../../utils/orderWasAlreadyCharged";
export var RefundsIA = function RefundsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REFUNDS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    }
  };
};
var getDescription = function getDescription(context, strictLocalize) {
  var withSharedParagraphs = function withSharedParagraphs(intro) {
    return [intro(strictLocalize), PLEASE_NOTE(strictLocalize), FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize)];
  };
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return withSharedParagraphs(REFUNDS_EXPLANATION);
  }
  if (orderTermIsNet60(brandOrder) && !orderWasAlreadyCharged(brandOrder)) {
    return withSharedParagraphs(WE_WILL_NOT_CHARGE_YOU);
  }
  if (orderTermIsPaymentOnShipment(brandOrder)) {
    return withSharedParagraphs(YOU_WILL_GET_A_REFUND);
  }
  return withSharedParagraphs(REFUNDS_EXPLANATION);
};
var REFUNDS = function REFUNDS(strictLocalize) {
  return strictLocalize({
    id: "j0Zb++",
    defaultMessage: [{
      "type": 0,
      "value": "Como funcionam os reembolsos"
    }]
  });
};
var WE_WILL_NOT_CHARGE_YOU = function WE_WILL_NOT_CHARGE_YOU(strictLocalize) {
  return strictLocalize({
    id: "nlChIa",
    defaultMessage: [{
      "type": 0,
      "value": "Como a encomenda foi efetuada utilizando as condições de pagamento a 60 dias e a fatura não foi paga, não cobraremos os artigos que está a devolver."
    }]
  });
};
var FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER = function FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize) {
  return strictLocalize({
    id: "8EzeWX",
    defaultMessage: [{
      "type": 0,
      "value": "As devoluções gratuitas são válidas apenas na primeira encomenda efetuada numa marca. Os custos de envio da devolução são cobertos pela Faire, mas os custos de envio originais e os direitos aduaneiros de importação não são reembolsáveis. Se uma fatura tiver sido paga com crédito Faire e um cartão de pagamento, o crédito será devolvido primeiro. Se, inicialmente, tiver sido utilizado o crédito Faire Direct para pagar uma encomenda que foi devolvida, esse montante não será reposto automaticamente na sua conta Faire como crédito."
    }]
  });
};
var YOU_WILL_GET_A_REFUND = function YOU_WILL_GET_A_REFUND(strictLocalize) {
  return strictLocalize({
    id: "HOxj0J",
    defaultMessage: [{
      "type": 0,
      "value": "Uma vez que a encomenda foi efetuada com a modalidade de pagamento no momento do envio, o custo dos artigos que está a devolver será reembolsado diretamente na forma de pagamento original quando a devolução for registada pela transportadora como estando em trânsito. Aguarde entre 5 e 10 dias úteis para que o reembolso apareça na sua forma de pagamento."
    }]
  });
};
var REFUNDS_EXPLANATION = function REFUNDS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DB4OtG",
    defaultMessage: [{
      "type": 0,
      "value": "Se tiver utilizado as condições de pagamento a 60 dias na encomenda e a fatura não tiver sido paga, não lhe debitaremos os artigos que está a devolver. Se tiver utilizado a opção de pagamento no envio quando efetuou a encomenda, o custo dos artigos que está a devolver será reembolsado diretamente na forma de pagamento original quando a devolução for registada pela transportadora como estando em trânsito. Aguarde entre 5 e 10 dias úteis para que o reembolso apareça na sua forma de pagamento."
    }]
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "Vr8ECj",
    defaultMessage: [{
      "type": 0,
      "value": "Tenha em atenção:"
    }]
  });
};